<template>
  <div></div>
</template>

<script setup lang="ts">
import { useLogin } from '@/composables/shared/useLogin';

const router = useRouter();

const { handleLoginWithRefreshToken } = useLogin();

const loginWithRefreshToken = async () => {
  try {
    await handleLoginWithRefreshToken();
  } catch (error) {
    console.debug('리프레시 토큰으로 로그인하기 핸들러가 실패했습니다', error);
    await router.push({ name: 'native-login' });
  }
};

onMounted(async () => {
  await loginWithRefreshToken();
});
</script>

<style scoped></style>
